import React from 'react';
import cn from 'classnames';
import './styles.scss';

const ModalList = ({ children, disc }) => {
	return (
		<ul className={cn('project-popup-list', { 'project-popup-list--disc': disc })}>
			{children}
		</ul>
	);
};

export default ModalList;
